module.exports = __webpack_public_path__ + "img/icon+circulo.212a3552.png";